import(/* webpackMode: "eager" */ "/home/agents/app/src/app/error.tsx");
